/* eslint-disable */

export interface ThreeDomainSecureRedirectUrl {
  /** HTTP GET or POST. */
  method?: string;
  /** The base URI. It doesn't contain any parameter data. */
  base_uri?: string;
  /** If method=GET these are URL params. If method=POST these are body params. */
  params?: { [key: string]: string };
}

export interface ThreeDomainSecureRedirectUrlParamsEntry {
  key: string;
  value: string;
}

/** Used by Franklin to send 3DS authentication data through the Risk pipeline. */
export interface ThreeDomainSecureAuthentication {
  outcome?: ThreeDomainSecureAuthenticationOutcome;
}

export enum ThreeDomainSecureAuthenticationOutcome {
  /** NOT_CHALLENGED - 3DS challenge was either skipped or not applicable. */
  NOT_CHALLENGED = "NOT_CHALLENGED",
  /** SUCCESS - The customer completed the 3DS challenge successfully. */
  SUCCESS = "SUCCESS",
  /** FAILED - The customer failed to complete the 3DS challenge successfully. */
  FAILED = "FAILED",
  /** CHALLENGED - The customer has been challenged and 3DS is pending completion. */
  CHALLENGED = "CHALLENGED",
}
